"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = WordFile;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

function WordFile(props) {
  var size = props.size,
      other = (0, _objectWithoutProperties2.default)(props, ["size"]);
  return _react.default.createElement("svg", (0, _extends2.default)({
    height: size,
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 16"
  }, other), _react.default.createElement("path", {
    d: "M9,7.44H9.69L8.89,11l-1-5H6.19L5,11,4.08,6H2.34l1.77,8h1.7L7,9.27,8.07,14H9.63l2-8H9V7.44Z"
  }), _react.default.createElement("path", {
    d: "M13.34,3.58A14.19,14.19,0,0,0,12,2,14.18,14.18,0,0,0,10.42.66,2.5,2.5,0,0,0,9,0H1.25A1.25,1.25,0,0,0,0,1.25v13.5A1.25,1.25,0,0,0,1.25,16h11.5A1.25,1.25,0,0,0,14,14.75V5a2.49,2.49,0,0,0-.66-1.42h0Zm-2.07-.85A13.63,13.63,0,0,1,12.4,4H10V1.59a13.52,13.52,0,0,1,1.27,1.13h0Zm1.73,12a0.25,0.25,0,0,1-.25.25H1.25A0.25,0.25,0,0,1,1,14.75V1.25A0.25,0.25,0,0,1,1.25,1H9V4.5a0.5,0.5,0,0,0,.5.5H13v9.75Z"
  }));
}

WordFile.propTypes = {
  size: _react.PropTypes.number
};
module.exports = exports.default;